import { ContactModel, AddressModel, CompanyModel, PersonModel } from "../../common/models/CommonModels";

export interface RegisterCompanyModel extends CompanyModel {
    termsAccepted: boolean
}

export const getEmptyRegisterCompanyModel = (): RegisterCompanyModel => {
    return {
        id: "",
        name: "",
        businessId: "",
        address: {
            streetAddress: "",
            postalCode: "",
            city: ""
        },
        contact: {
            email: "",
            emailDetails: "",
            phoneNumber: "",
            phoneDetails: ""
        },        
        contactPerson: {
            id: "",
            firstName: "",
            lastName: "",
            contact: {
                email: "",
                emailDetails: "",
                phoneNumber: "",
                phoneDetails: ""
            }
        },
        website: "",
        termsAccepted: false,
        announcementCount: 0
    }
}


// WEBPACK FOOTER //
// ./src/register/company/RegisterCompanyModels.ts